module.exports = __webpack_public_path__ + "img/icon-star.05dde7a0.svg";